import { Link } from 'react-router-dom';
import { getBagelConfigPath } from 'utils/navigation';
import defaultStyles from './BagelChatWidget.module.scss';

const styles = defaultStyles;

export interface ISearchDocSource {
  text: string;
  title: string;
  year?: string;
  sourceId: string;
  documentUrl?: string;
  fileType?: string;
  category?: string;
}

interface IToolResult {
  found?: boolean;
  results?: ISearchDocSource[];
  message?: string;
}

interface IToolResultCardProps {
  toolName: string;
  result: IToolResult;
}

function uniqueSources(results: ISearchDocSource[]): ISearchDocSource[] {
  const seen = new Set<string>();
  return results.filter(r => {
    if (seen.has(r.sourceId)) return false;
    seen.add(r.sourceId);
    return true;
  });
}

function visibleSources(results: ISearchDocSource[]): ISearchDocSource[] {
  return uniqueSources(results).filter(
    r => r.title?.trim() && (r.documentUrl || r.sourceId),
  );
}

function SourcePills({ results }: { results: ISearchDocSource[] }) {
  const sources = visibleSources(results);
  if (sources.length === 0) return null;

  return (
    <div className={styles.sources}>
      <p className={styles.sourcesLabel}>Sources</p>
      <div className={styles.sourcePills}>
        {sources.map(r => {
          const label = `${r.year ? `${r.year} — ` : ''}${r.title}`;

          if (r.documentUrl) {
            return (
              <a
                key={r.sourceId}
                href={r.documentUrl}
                className={styles.sourcePill}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            );
          }

          return (
            <Link
              key={r.sourceId}
              to={getBagelConfigPath()}
              className={styles.sourcePill}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default function ToolResultCard({
  toolName,
  result,
}: IToolResultCardProps) {
  if (toolName === 'search_knowledge_base' || toolName === 'search_docs') {
    if (!result.found || !result.results?.length) return null;
    return <SourcePills results={result.results} />;
  }

  return null;
}
